module.exports = __webpack_public_path__ + "static/media/photo126.bc662c78.jpg";